import EventInsightsPage from './EventInsights';

export default EventInsightsPage;